import script from "./Export2Excel.vue?vue&type=script&setup=true&lang=js"
export * from "./Export2Excel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__